// extracted by mini-css-extract-plugin
export var header = "_fw-0";